import React from "react";
import { Box, Typography } from "@mui/material";
import { Toolbar } from "./components/Toolbar";

export function HomePage() {
  return (
    <>
      <Toolbar />
      <Box
        bgcolor="#092E63"
        sx={{
          height: "100%",
          padding: "1.563rem",
          paddingTop: "2.375rem",
        }}
      >
        <Typography
          color="white"
          sx={{
            fontSize: "1.625rem",
            fontWeight: "lighter",
          }}
        >
          Please use the scholarship search link that we provided to you.
        </Typography>
      </Box>
    </>
  );
}
